



















































































































































































































































































































































import settings from '@/settings'
import n from '@/utils/notifications'
import m from '@/graphql/mutation'
import q from '@/graphql/query'
import t from '@/utils/tools'
import d from '@/utils/imports'
import af from '@/utils/authorized_formats'

export default {
    name: 'company_form'

    watch:
        "uid": (value)->
            # console.log "WATCH UID", value
            if @origin == "company"
                @get_company()

    props: {
        uid: {
            type: String
            default: ''
        }
        origin: {
            type: String
            required: true
        }
    }

    data: ()->
        admin_email_content: "Cet email servira d'identifiant"
        true: true
        false: false
        logo_url: ''
        distribution_logo_url: ''
        step: 0.01
        min: 0
        zipcode_nbr_error: ['Le numéro du code postal doit contenir 5 chiffres']
        errors: {}
        company_logo_max_filesize: af['company']['logo']['max_filesize']/1024/1024
        company_logo_authorized_formats: af['company']['logo']['authorized_formats']
        distribution_logo_max_filesize: af['distribution']['logo']['max_filesize']/1024/1024
        distribution_logo_authorized_formats: af['distribution']['logo']['authorized_formats']
        distributions: []
        legal_form_choices: [] 
        stats:[]
        active_names: [1]
        active_name_medical: [1]
        company: {
            uid: ''
            legal_form: {uid: ''}
            reference: ''
            name: ''
            ape_naf_code: ''
            siret: ''
            employees_nb: 0
            logo_name: ''
            logo_data: ''
            address: ''
            address2: ''
            zipcode: ''
            city: ''
            phone: ''
            email: ''
            opco: ''
            opco_member_number:''
            opco_address:''
            opco_address2:''
            opco_zipcode:''
            opco_city:''
            opco_link:''
            medical: ''
            medical_member_number:''
            medical_address:''
            medical_address2:''
            medical_zipcode:''
            medical_city:''
            medical_link:''
            voluntary_contribution: false
            voluntary_contribution_amount: 0
            distribution: {
                uid: ''
                is_distributor: false
                distributed_by_uid: ''
                white_label: false
                distribution_logo_name: ''
                distribution_logo_data: ''
                admin_email: ''   
            }      
        }
        contact_opco: [
            uid:''
            company_uid:@uid
            firstname:''
            lastname:''
            phone:''
            email:''   
        ]
        contact_medical: [
            uid:''
            company_uid:@uid
            firstname:''
            lastname:''
            phone:''
            email:''   
        ]
        

    computed:
        readonly: ()->
            readonly = t.has_access_right('company_edit')
            return !readonly
        toggle_collapse_text: ()->
            text = "Liste de contacts"
            if @active_names.length > 1
                text = "Fermer"
            return text
        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon
        toggle_collapse_text_medical: ()->
            text = "Liste de contacts"
            if  @active_name_medical.length > 1
                text = "Fermer"
            return text
        toggle_collapse_icon_medical: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_name_medical.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon


        ref_readonly: ()->
            return !t.has_access_right(d['companies']['access_set'][0])

        user_is_admin: ()->
            return @$store.state.user_datas.profiles.indexOf('distributor') != -1 or @$store.state.user_datas.profiles.indexOf('superadmin') != -1

        not_my_distri: ()->
            return @$store.state.user_datas.profiles.indexOf('superadmin') != -1 or @$store.state.user_datas.profiles.indexOf('distributor') != -1 and @company.uid != @$store.state.user_datas.company.uid

        superadmin_company: ()->
            return @company.name == "NÄSTA" and @$store.state.user_datas.profiles.indexOf('superadmin') != -1

    methods:
        zipcode_nbr_change: (company)->
            if company.zipcode.length > 0 and isNaN(company.zipcode)
                @errors['zipcode'] = @zipcode_nbr_error
                return

            if company.opco_zipcode.length > 0 and isNaN(company.opco_zipcode)
                @errors['opco_zipcode'] = @zipcode_nbr_error
                return
            if company.medical_zipcode.length > 0 and isNaN(company.medical_zipcode)
                @errors['medical_zipcode'] = @zipcode_nbr_error
                return

            if company.zipcode.length > 0 and company.zipcode.length != 5 and Object.keys(@errors).indexOf('zipcode') == -1
                @errors['zipcode'] = @zipcode_nbr_error

            if company.opco_zipcode.length > 0 and company.opco_zipcode.length != 5 and Object.keys(@errors).indexOf('opco_zipcode') == -1
                @errors['opco_zipcode'] = @zipcode_nbr_error
            
            if company.medical_zipcode.length > 0 and company.medical_zipcode.length != 5 and Object.keys(@errors).indexOf('medical_zipcode') == -1
                @errors['medical_zipcode'] = @zipcode_nbr_error

            if (company.zipcode.length == 5 || company.zipcode.length == 0) && Object.keys(@errors).indexOf('zipcode') != -1
                delete @errors['zipcode']
                
            if (company.opco_zipcode.length == 5 || company.opco_zipcode.length == 0) && Object.keys(@errors).indexOf('opco_zipcode') != -1
                delete @errors['opco_zipcode']
            if (company.medical_zipcode.length == 5 || company.medical_zipcode.length == 0) && Object.keys(@errors).indexOf('medical_zipcode') != -1
                delete @errors['medical_zipcode']
            return

        add_contact_opco: ()->
            @contact_opco.push
                uid:''
                company_uid:@uid
                firstname:''
                lastname:''
                phone:''
                email:'' 
            return
        add_contact_medical: ()->
            @contact_medical.push
                uid:''
                company_uid:@uid
                firstname:''
                lastname:''
                phone:''
                email:'' 
            return
        remove_contact_opco: (index)->
            self = @
            if index.uid != ""
                self.delete_contact_opco(index.uid)
                self.contact_opco.pop()
            else
                self.contact_opco.pop()   
            return
        remove_contact_medical: (index)->
            self = @
            if index.uid != ""
                self.delete_contact_medical(index.uid)
                self.contact_medical.pop()
            else
                self.contact_medical.pop()   
            return
        
        window_link: (item)->
            self = @
            href = item
            if item.indexOf('https') == -1
                href = 'https://' + item
            if item.includes('http')
                href = item
            window.open(href, '_blank')

        telephone_change: (item)->
            item.phone = t.phone_format(item.phone)
            return

        company_logo_change: (file, fileList)->
            @handle_image_change('company', file, fileList)
            return

        company_distribution_logo_change: (file, fileList)->
            @handle_image_change('distribution', file, fileList)
            return

        company_logo_remove: (file, fileList)->
            @logo_url = ''
            @company.logo_data = ''
            @company.logo_name = ''
            return

        company_distribution_logo_remove: (file, fileList)->
            @distribution_logo_url = ''
            @company.distribution_logo_data = ''
            @company.distribution_logo_name = ''
            return

        handle_image_change: (from, file, fileList)->
            is_good_ext = file.raw.type in af[from]['logo']['mime_types']
            is_good_size = file.size < af[from]['logo']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'Le logo doit être une image de type '+@[from+'_logo_authorized_formats']+'.')
                return
            if !is_good_size
                n.file_error('Erreur', 'Le logo ne peut pas excéder '+@[from+'_logo_max_filesize']+'Mo.')
                return

            if from == "company"
                @logo_url = URL.createObjectURL(file.raw)
            else
                @distribution_logo_url = URL.createObjectURL(file.raw)

            self = @
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                if from == "company"
                    self.company.logo_data = e.target.result
                    self.company.logo_name = file.name
                else
                    self.company.distribution.distribution_logo_data = e.target.result
                    self.company.distribution.distribution_logo_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "IMAGE", @company
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        select_style: (count)->
            return "margin-left:"+(count*15).toString()+"px;"

        distributions_factory: (distribution, count)->
            if distribution.is_distributor and distribution.company.is_active
                @distributions.push({uid:distribution.uid, company:distribution.company, count:count})
                if @origin == 'add'
                    if distribution.company.uid == @$store.state.user_datas.company.uid
                        @company.distribution.distributed_by_uid = distribution.uid
                        # console.log "SET DISTRIBUTED BY", @company.distribution.distributed_by
            count++
            for key, value of distribution.children
                @distributions_factory(value, count)
            # console.log "DISTRIBUTIONS FACTORY", JSON.stringify(@distributions)
            return

        get_distributions: ()->
            self = @
            @distributions = []
            q.run('get_distribution_set', [@$store.state.user_datas.company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_form: get_distributions: then" ,e.message)
                else
                    # if resp.body.data.distribution_set[0].distributed_by != null
                    #     self.distributions.push({uid:resp.body.data.distribution_set[0].distributed_by.uid, company:resp.body.data.distribution_set[0].distributed_by.company, count:0})
                    self.distributions_factory(resp.body.data.distribution_set[0], 1)
            .catch (resp)->
                n.catch_error(resp, "company_form: get_distributions()")

        get_company: ()->
            self = @
            @errors = {}
            q.run('get_company', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_form: get_company: then" ,e.message)
                else
                    # console.log "GET COMPANY : ", resp.body.data.company
                    self.company = resp.body.data.company
                    self.get_company_stats()
                    self.logo_url = ""
                    self.distribution_logo_url = ""
                    if self.company.logo != ""
                        self.logo_url = settings.media_url+self.company.logo_dir+"/"+self.company.logo
                    if self.company.distribution.distribution_logo != ""
                        self.distribution_logo_url = settings.media_url+self.company.distribution.distribution_logo_dir+"/"+self.company.distribution.distribution_logo
                    if self.company.zipcode.length > 0 and self.company.zipcode.length != 5
                        self.errors['zipcode'] = self.zipcode_nbr_error
                    if self.company.opco_zipcode.length > 0 and self.company.opco_zipcode.length != 5
                        self.errors['opco_zipcode'] = self.zipcode_nbr_error
            .catch (resp)->
                n.catch_error(resp, "company_form: get_company()")

        get_company_stats: ()->
            self = @
            q.run('get_company_stats', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_form: get_company_stats: then" ,e.message)
                else
                    self.stats = resp.body.data.company.stats
            .catch (resp)->
                n.catch_error(resp, "company_form: get_company_stats()")

        get_contact_opco: ()->
            self = @
            @errors = {}
            q.run('get_contact_opco_set', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("contact_opco: get_contact_opco_set: then" ,e.message)
                else
                    # console.log "GET CONTACT_OPCO : ", resp.body.data.contact_opco_set
                    self.contact_opco = resp.body.data.contact_opco_set
            .catch (resp)->
                n.catch_error(resp, "contact_opco: get_contact_opco()")
        
        get_contact_medical: ()->
            self = @
            @errors = {}
            q.run('get_contact_medical_set', [@uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("contact_medical: get_contact_medical_set: then" ,e.message)
                else
                    # console.log "GET CONTACT_medical : ", resp.body.data.contact_medical_set
                    self.contact_medical = resp.body.data.contact_medical_set
            .catch (resp)->
                n.catch_error(resp, "contact_medical: get_contact_medical()")

        get_legal_form_choices: ()->
            self = @
            @errors = {}
            q.run('get_type_set', ['legal_form_choice'])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_form: get_legal_form_choices: then" ,e.message)
                else
                    # console.log "GET LEGAL FORM CHOICES : ", resp.body.data.legal_form_choice_set
                    self.legal_form_choices = resp.body.data.legal_form_choice_set
            .catch (resp)->
                n.catch_error(resp, "company_form: get_legal_form_choices()")

        # Delete contact_opco
        delete_contact_opco: (contact_opco_id)->
            # console.log  "DELETE CONTACT_OPCO", evaluation_uid
            self = @
            # console.log "CONTACT_OPCO DELETE", evaluation_uid
            m.run('delete_object',['contact_opco',contact_opco_id])
            .then (resp)->
                # console.log "DELETE CONTACT_OPCO", resp.body.data.contact_opco_deletion
                if resp.body.data.contact_opco_deletion.ok
                    n.success_message('Suppression Contact OPCO effectué')
                    self.get_contact_opco()
                else
                    n.gql_error("contact_opco: delete_contact_opco: then", resp.body.data.contact_opco_deletion.message)
            .catch (resp)->
                n.catch_error(resp, "contact_opco: delete_contact_opco()")
        
        delete_contact_medical: (contact_medical_id)->
            # console.log  "DELETE CONTACT_MEDICAL", evaluation_uid
            self = @
            # console.log "CONTACT_MEDICAL DELETE", evaluation_uid
            m.run('delete_object',['contact_medical',contact_medical_id])
            .then (resp)->
                # console.log "DELETE CONTACT_MEDICAL", resp.body.data.contact_medical_deletion
                if resp.body.data.contact_medical_deletion.ok
                    n.success_message('Suppression Contact Service de Santé au Travail effectué')
                    self.get_contact_medical()
                else
                    n.gql_error("contact_medical: delete_contact_medical: then", resp.body.data.contact_medical_deletion.message)
            .catch (resp)->
                n.catch_error(resp, "contact_medical: delete_contact_medical()")


        save: ()->
            # console.log "SAVE COMPANY ", @company
            self = @
            if self.company.uid == "" and !self.user_is_admin
                self.$router.push(name:"dashboard")
                return
            if !self.company.distribution.is_distributor
                self.company.distribution.admin_email = ""
                self.company.distribution.white_label = false
            if self.company.distribution.distributed_by_uid == "Aucune"
                self.company.distribution.distributed_by_uid = ''
            if Object.keys(@errors).indexOf('zipcode') != -1
                n.form_error()
                return
            m.run('save_company', [self.company])
            .then (resp)->
                # console.log "SAVE THEN ", resp
                if resp.body.data.company_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.company_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.company_form_mutation.errors
                    self.errors = resp.body.data.company_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    if self.save_contact_opco() || self.save_contact_medical()
                        n.success()
                        if !self.company.distribution.white_label
                            self.distribution_logo_url = ""
                        # console.log "SAVE COMPANY OK ", self.uid, self.company.name
                        if self.origin == "add"
                            self.$store.commit('set_selected_company', {uid:resp.body.data.company_form_mutation.form_ret, name:self.company.name})
                            # console.log "NEW COMPANY IN STORE", self.$store.state.selected_company
                            self.$router.push({name:'company_company', params:{uid:resp.body.data.company_form_mutation.form_ret}})
                        else
                            # console.log "EMIT AFTER SAVE"
                            self.get_company()
                            if self.user_is_admin
                                self.get_distributions()
                            self.$emit('change-distribution')
                    # console.log "D LOGO URL", self.distribution_logo_url
            .catch (resp)->
                # console.log "CATCH ", resp
                n.catch_error(resp, "company_form: save()")
        save_contact_opco: ()->
            # console.log "SAVE CONTACT_OPCO"
            self = @
            bool = true
            # console.log(self.contact_opco)
            if Object.keys(self.errors).indexOf('opco_zipcode') != -1
                n.form_error()
                return
            self.contact_opco.forEach (contact_opco)->
                m.run('save_contact_opco',[contact_opco])
                .then (resp)->
                    if bool == true
                        if resp.body.data.contact_opco_form_mutation.form_ret == 'failed'
                            return n.access_denied()
                        if resp.body.data.contact_opco_form_mutation.errors.length > 0
                            bool = false
                            # console.log "ERRORS", resp.body.data.contact_opco_form_mutation.errors
                            self.errors = resp.body.data.contact_opco_form_mutation.errors.reduce(
                                (acc, el)->
                                    acc[el.field] = el.messages
                                    return acc
                            ,{})
                            n.form_error()
                        else
                            if contact_opco.uid == ""
                                n.success_message('Enregistrement Contact OPCO effectué')
                            self.get_contact_opco()
                            self.active_names = [1]
                            self.active_name_medical = [1]
                            self.errors = {}
                .catch (resp)->
                    # console.log "CATCH ", resp
                    n.catch_error(resp, "contact_opco_form: save()")
        save_contact_medical: ()->
            # console.log "SAVE CONTACT_medical"
            self = @
            bool = true
            # console.log(self.contact_medical)
            if Object.keys(self.errors).indexOf('medical_zipcode') != -1
                n.form_error()
                return
            self.contact_medical.forEach (contact_medical)->
                m.run('save_contact_medical',[contact_medical])
                .then (resp)->
                    if bool == true
                        if resp.body.data.contact_medical_form_mutation.form_ret == 'failed'
                            return n.access_denied()
                        if resp.body.data.contact_medical_form_mutation.errors.length > 0
                            bool = false
                            # console.log "ERRORS", resp.body.data.contact_medical_form_mutation.errors
                            self.errors = resp.body.data.contact_medical_form_mutation.errors.reduce(
                                (acc, el)->
                                    acc[el.field] = el.messages
                                    return acc
                            ,{})
                            n.form_error()
                        else
                            if contact_medical.uid == ""
                                n.success_message('Enregistrement Contact medical effectué')
                            self.get_contact_medical()
                            self.active_name_medical = [1]
                            self.errors = {}
                .catch (resp)->
                    # console.log "CATCH ", resp
                    n.catch_error(resp, "contact_medical_form: save()")

    beforeMount: ()->
        @get_contact_opco()
        @get_contact_medical()
        @get_legal_form_choices()
        # console.log "COMPANY FORM BEFORE", @uid, @origin
        if @origin == "company"
            @get_company()
        if @user_is_admin
            @get_distributions()
}
